import PropTypes from 'prop-types'
import React from 'react'

import './NextMeeting.css'


const NextMeeting = ({date_time, loc, address}) => {
  if (!date_time) {
    return null
  }

  return (
    <div className="NextMeeting">
      <div className="NextMeeting-inner">
        <p>The next meeting is {date_time} at {loc} ({address}).</p>
      </div>
    </div>
  )
}

NextMeeting.propTypes = {
  date_time: PropTypes.string,
  loc: PropTypes.string,
  address: PropTypes.string
}

export default NextMeeting



// WEBPACK FOOTER //
// ./src/NextMeeting.js